export default {
  "offerPolicy": {
    "title": "Conditions de ventes tarifaires",
    "content": {
      "policies": [
        {
          "label": "Politique de garantie",
          "description": "Toutes les r\u00e9servations doivent \u00eatre garanties avec une carte bancaire valide \u00e0 la date du d\u00e9but de votre s\u00e9jour. Sauf mention sp\u00e9ciale."
        },
        {
          "label": "D\u00e9lai d\u0027annulation",
          "description": "Annulation sans frais jusqu\u0027\u00e0 1 jour avant l\u0027arriv\u00e9e, 12:00 (Heure locale). Au del\u00e0, l\u0027h\u00f4tel facture la premi\u00e8re nuit."
        },
        {
          "label": "Heure d\u0027enregistrement",
          "description": "La chambre est disponible \u00e0 partir de 15:00 sauf en cas de Early Check In."
        },
        {
          "label": "Heure de d\u00e9part",
          "description": "La chambre doit \u00eatre lib\u00e9r\u00e9e au plus tard \u00e0 11:00."
        },
        {
          "label": "Politique enfant",
          "description": "L h\u00e9bergement et le petit-d\u00e9jeuner sont gratuits pour les enfants de moins de 3 ans h\u00e9berg\u00e9s dans la chambre des parents dans la limite de la capacit\u00e9 d accueil. Le PDJ enfant (jusqu \u00e0 12 ans) est \u00e0 prix r\u00e9duit -50% et est \u00e0 r\u00e9gler \u00e0 la r\u00e9ception."
        },
        {
          "label": "Produits inclus dans Forfait(s)",
          "description": "Taxes et charges (eau, \u00e9lectricit\u00e9, chauffage), \u00e0 l\u0027exception de la taxe de s\u00e9jour"
        },
        {
          "label": "Documents officiels demand\u00e9s",
          "description": "La carte bancaire ayant servi \u00e0 la r\u00e9servation vous sera demand\u00e9e lors de votre arriv\u00e9e. Le nom figurant sur votre pi\u00e8ce d\u0027identit\u00e9 devra \u00eatre identique \u00e0 celui indiqu\u00e9 sur la carte de cr\u00e9dit."
        },
        {
          "label": "Prestation de m\u00e9nage",
          "description": "1 \u00e0 7 nuits : m\u00e9nage payant en option \/ 8 nuits et + : m\u00e9nage hebdomadaire"
        },
        {
          "label": "Conditions du tarif membres",
          "description": "Etre ou devenir membre ALL - Accor Live Limitless. Le membre doit pr\u00e9senter sa carte d\u00e8s son arriv\u00e9e \u00e0 l\u0027h\u00f4tel (ou son num\u00e9ro de membre s\u0027il n\u0027a pas encore re\u00e7u sa carte). Maximum 2 chambres au Tarif Membres peuvent \u00eatre r\u00e9serv\u00e9es par membre et par s\u00e9jour"
        },
        {
          "label": "Informations l\u00e9gales",
          "description": "Soci\u00e9t\u00e9 PV-CP CITY, RCS de Paris n\u00b0513 635 987, domicili\u00e9e Espace pont de Flandre - 11 rue de Cambrai - 75947 PARIS Cedex 19, au capital de 992 470 euros, FR20513635987"
        }
      ]
    }
  },
  "offerDetails": {
    "title": "D\u00e9tail (EUR)",
    "rateSubTitle": "R\u00e9servez en toute tranquillit\u00e9, votre s\u00e9jour est modifiable et annulable sans frais.",
    "content": {
      "total": {
        "title": "Montant",
        "total": "550.05\u20ac",
        "duration": [],
        "description": {
          "club": {
            "title": "ALL - Accor Live Limitless"
          },
          "value": "\u003Ca href=\u0022#create-account\u0022 class=\u0022create-account\u0022\u003EDevenez membre\u003C\/a\u003E ALL - Accor Live Limitless pour b\u00e9n\u00e9ficier imm\u00e9diatement de ce tarif. C\u2019est simple rapide et gratuit !"
        }
      },
      "breakfast": {
        "title": "Petit-d\u00e9jeuner\/adulte",
        "total": "54.00\u20ac*",
        "duration": [
          {
            "value": "09\/01\/2024 - 12\/01\/2024",
            "amount": "18.00\u20ac*"
          },
          {
            "value": "10\/01\/2024 - 13\/01\/2024",
            "amount": "18.00\u20ac*"
          },
          {
            "value": "11\/01\/2024 - 14\/01\/2024",
            "amount": "18.00\u20ac*"
          }
        ],
        "meal_description": "Prix \u200b\u200bdu petit-d\u00e9jeuner \u00e0 l\u0027h\u00f4tel par adulte",
        "policies": [
          "Toutes les r\u00e9servations doivent \u00eatre garanties avec une carte bancaire valide \u00e0 la date du d\u00e9but de votre s\u00e9jour. Sauf mention sp\u00e9ciale.",
          "Annulation sans frais jusqu\u0027\u00e0 1 jour avant l\u0027arriv\u00e9e, 12:00 (Heure locale). Au del\u00e0, l\u0027h\u00f4tel facture la premi\u00e8re nuit.",
          "La chambre est disponible \u00e0 partir de 15:00 sauf en cas de Early Check In.",
          "La chambre doit \u00eatre lib\u00e9r\u00e9e au plus tard \u00e0 11:00.",
          "L h\u00e9bergement et le petit-d\u00e9jeuner sont gratuits pour les enfants de moins de 3 ans h\u00e9berg\u00e9s dans la chambre des parents dans la limite de la capacit\u00e9 d accueil. Le PDJ enfant (jusqu \u00e0 12 ans) est \u00e0 prix r\u00e9duit -50% et est \u00e0 r\u00e9gler \u00e0 la r\u00e9ception.",
          "Taxes et charges (eau, \u00e9lectricit\u00e9, chauffage), \u00e0 l\u0027exception de la taxe de s\u00e9jour",
          "La carte bancaire ayant servi \u00e0 la r\u00e9servation vous sera demand\u00e9e lors de votre arriv\u00e9e. Le nom figurant sur votre pi\u00e8ce d\u0027identit\u00e9 devra \u00eatre identique \u00e0 celui indiqu\u00e9 sur la carte de cr\u00e9dit.",
          "1 \u00e0 7 nuits : m\u00e9nage payant en option \/ 8 nuits et + : m\u00e9nage hebdomadaire",
          "Etre ou devenir membre ALL - Accor Live Limitless. Le membre doit pr\u00e9senter sa carte d\u00e8s son arriv\u00e9e \u00e0 l\u0027h\u00f4tel (ou son num\u00e9ro de membre s\u0027il n\u0027a pas encore re\u00e7u sa carte). Maximum 2 chambres au Tarif Membres peuvent \u00eatre r\u00e9serv\u00e9es par membre et par s\u00e9jour",
          "Soci\u00e9t\u00e9 PV-CP CITY, RCS de Paris n\u00b0513 635 987, domicili\u00e9e Espace pont de Flandre - 11 rue de Cambrai - 75947 PARIS Cedex 19, au capital de 992 470 euros, FR20513635987"
        ],
        "tax": {
          "included": {
            "label": "Le montant total de votre r\u00e9servation comprend les taxes et charges suivantes\u00a0:",
            "value": [
              "TVA Taxe pays sur la restauration : 10.0 % (par nuit \/ par chambre)",
              "TVA Taxe pays sur chambre uniquement : 10.0 % (par nuit \/ par chambre)"
            ]
          },
          "not_included": {
            "label": "Le montant total de votre r\u00e9servation ne comprend pas les taxes et charges suivantes :",
            "value": [
              "Taxe R\u00e9gionale Additionnelle Mob : 5,00 EUR (par nuit \/ par personne)",
              "Taxe municipale et locale : 2,50 EUR (par nuit \/ par personne)",
              "Taxe additionnelle r\u00e9gionale IDF : 0,38 EUR (par nuit \/ par personne)",
              "Taxe d\u00e9partementale : 0,25 EUR (par nuit \/ par personne)"
            ]
          }
        }
      }
    }
  }
}
